import React, { useState } from 'react';
import styled from 'styled-components';
import { CONST_CHAT_MANAGEMENT } from 'constants/language';
import { apiSaveWebFCMToken } from 'api/operator';
import { firebaseMessaging } from '@hooks/useFireBase/useFireBase';

const BannerWrapper = styled.div`
  background-color: #fff8e1;
  border-bottom: 1px solid #f0c040;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  color: #5a4400;
  width: 100%;

  button.enable-btn {
    background-color: #52b788;
    color: #fff;
    border: none;
    border-radius: 0.375rem;
    padding: 0.25rem 0.75rem;
    cursor: pointer;
    font-size: 0.875rem;
    white-space: nowrap;

    &:hover {
      background-color: #40916c;
    }
  }
`;

const NotificationPermissionBanner = () => {
  const [permission, setPermission] = useState<NotificationPermission>(
    'Notification' in window ? Notification.permission : 'granted'
  );

  // Already granted — no banner needed
  if (!('Notification' in window) || permission === 'granted') {
    return null;
  }

  const handleEnable = () => {
    Notification.requestPermission().then((result) => {
      setPermission(result);
      if (result === 'granted') {
        window.dispatchEvent(new Event('notification-permission-granted'));
        const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;
        const messaging = firebaseMessaging;
        if (messaging && vapidKey) {
          navigator.serviceWorker
            .register('/firebase-messaging-sw.js')
            .then((reg) => messaging.getToken({ vapidKey, serviceWorkerRegistration: reg }))
            .then((token) => {
              if (token) apiSaveWebFCMToken(token).catch(() => {});
            })
            .catch(() => {});
        }
      }
    });
  };

  // Denied: user must enable manually in browser settings
  if (permission === 'denied') {
    return (
      <BannerWrapper>
        <span>🔔 {CONST_CHAT_MANAGEMENT.NOTIFICATION_BANNER_DENIED_TEXT}</span>
      </BannerWrapper>
    );
  }

  // Default: prompt user to enable
  return (
    <BannerWrapper>
      <span>🔔 {CONST_CHAT_MANAGEMENT.NOTIFICATION_BANNER_TEXT}</span>
      <button className="enable-btn" onClick={handleEnable}>
        {CONST_CHAT_MANAGEMENT.NOTIFICATION_BANNER_ENABLE}
      </button>
    </BannerWrapper>
  );
};

export default NotificationPermissionBanner;
